import { render, staticRenderFns } from "./SubfactorsStep.vue?vue&type=template&id=3a56df4a&scoped=true&"
import script from "./SubfactorsStep.vue?vue&type=script&lang=js&"
export * from "./SubfactorsStep.vue?vue&type=script&lang=js&"
import style0 from "./SubfactorsStep.vue?vue&type=style&index=0&id=3a56df4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a56df4a",
  null
  
)

export default component.exports